import {
  consultarEstadoImpressoraQz,
  imprimirPdfsQz,
  listarImpressorasQz,
} from "@/modules/Restaurante/services/qzTrayPrinter";

export async function imprimirDocumentosPdv({
  tipo,
  id,
  urls,
  impressora,
  tentativas,
  imprimirManual,
}) {
  const documentos = urls.filter(Boolean);
  if (!impressora || !impressora.trim()) {
    documentos.forEach(imprimirManual);
    return documentos;
  }
  if (!documentos.length) return documentos;

  const chave = `${tipo}:${id}`;
  if (tentativas.has(chave)) return documentos;
  tentativas.add(chave);

  const impressoras = await listarImpressorasQz();
  if (!impressoras.includes(impressora)) {
    const error = new Error(`A impressora "${impressora}" não foi encontrada no QZ Tray.`);
    error.code = "QZ_PRINTER_NOT_FOUND";
    throw error;
  }
  const estado = await consultarEstadoImpressoraQz(impressora).catch(() => ({ estado: "desconhecido" }));
  if (estado.estado === "indisponivel") {
    throw new Error(`A impressora "${impressora}" está indisponível (${estado.status || "offline"}).`);
  }
  if (tipo === "conferencia") {
    await imprimirPdfsQz(
      impressora,
      documentos,
      { orientation: "portrait", colorType: "blackwhite" },
      { altFontRendering: true }
    );
  } else {
    await imprimirPdfsQz(impressora, documentos);
  }
  return documentos;
}
